var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[(_vm.loading)?_c('full-loader'):(_vm.error)?_c('error-page'):_c('Layout',[_c('nav-panel'),_c('Content',[_c('div',{staticClass:"layout-cover"}),_c('div',{staticClass:"layout-inner"},[_c('router-view')],1)])],1),_c('about-modal'),_c('download-widget')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }